import { render, staticRenderFns } from "./AgendaItems.vue?vue&type=template&id=ee644c80&scoped=true&"
import script from "./AgendaItems.vue?vue&type=script&lang=js&"
export * from "./AgendaItems.vue?vue&type=script&lang=js&"
import style0 from "./AgendaItems.vue?vue&type=style&index=0&id=ee644c80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee644c80",
  null
  
)

export default component.exports